import {
  Calculator,
  FileCheck2,
  FileSliders,
  Presentation,
  ScanLine,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Product {
  id: string
  name: string
  category: string
  summary: string
  status: '内测中' | '开发中'
  icon: LucideIcon
  accent: string
}

export const products: Product[] = [
  {
    id: 'cost-estimate',
    name: '智能成本测算',
    category: '商务与成本',
    summary: '从工程量清单出发，结合企业成本标准、规则与工程证据，形成可解释的成本拆分和测算草案。',
    status: '内测中',
    icon: Calculator,
    accent: '#087f5b',
  },
  {
    id: 'contract-review',
    name: '合同风险智能审查',
    category: '法务与合规',
    summary: '多智能体协同识别合同风险，定位关键条款并形成专业研判与修改建议。',
    status: '内测中',
    icon: FileCheck2,
    accent: '#b24b2c',
  },
  {
    id: 'cad-viewer',
    name: 'CAD 图纸工作台',
    category: '工程工具',
    summary: '打开矢量图纸、识别图框和表格，并围绕结构化图纸信息开展专业对话。',
    status: '内测中',
    icon: ScanLine,
    accent: '#1769aa',
  },
  {
    id: 'meeting-minutes',
    name: '会议纪要工作台',
    category: '项目协同',
    summary: '从会议原文中提取决议、行动项和责任人，形成可编辑、可交付的结构化纪要。',
    status: '内测中',
    icon: FileSliders,
    accent: '#7a4fa3',
  },
  {
    id: 'ppt-generator',
    name: 'PPT 生成工作台',
    category: '内容创作',
    summary: '把主题和素材整理成结构化演示文稿，支持模板切换、逐页微调和可编辑文件导出。',
    status: '内测中',
    icon: Presentation,
    accent: '#c07c16',
  },
]
